import { Modal } from 'antd'
import { ALLOWED_ATTACHMENT_SOURCE_TYPE } from '@OpsQuality/constants'
import { UploadModalType } from '@OpsQuality/types'
import { isProcessTypeCertificationOrInspection } from '@OpsQuality/JobRequestDetails/components/logic'
import styles from '@OpsQuality/components/Inspection/components/styles.css'
import HybridProcesses from '@OpsQuality/components/Inspection/components/HybridProcesses'
import SingularProcess from '@OpsQuality/components/Inspection/components/SingularProcess'

import Box from '~/core/Box'

export default function UploadModal(props: UploadModalType) {
    const { onCancel, jobRequestId, attachmentTypeDetails, isJobCompleted } =
        props

    const { attachmentTypeData, jobRequestLinesByProcessTypeOrMaterialType } =
        attachmentTypeDetails

    const areProcessesGrouped =
        jobRequestLinesByProcessTypeOrMaterialType &&
        jobRequestLinesByProcessTypeOrMaterialType.length > 0 &&
        isProcessTypeCertificationOrInspection(
            jobRequestLinesByProcessTypeOrMaterialType[0],
        )

    return (
        <Modal
            visible
            bodyStyle={{ padding: '0px' }}
            closable
            cancelText="Done"
            cancelButtonProps={{ type: 'primary', style: { width: '100%' } }}
            okButtonProps={{ style: { display: 'none' } }}
            onCancel={onCancel}
            width="400px"
        >
            <Box direction="col" className={styles.inspectionFragmentCard}>
                <Box direction="col" className={styles.inspectionFragmentWrap}>
                    <Box className={styles.inspectionFragmentHeader}>
                        {`Upload ${attachmentTypeData.title}`}
                    </Box>
                    {areProcessesGrouped ? (
                        <HybridProcesses
                            jobRequestId={jobRequestId}
                            attachmentTypeDetails={attachmentTypeDetails}
                            attachmentSource={ALLOWED_ATTACHMENT_SOURCE_TYPE.QC}
                            isJobCompleted={isJobCompleted}
                        />
                    ) : (
                        <SingularProcess
                            jobRequestId={jobRequestId}
                            attachmentTypeDetails={attachmentTypeDetails}
                            attachmentSource={ALLOWED_ATTACHMENT_SOURCE_TYPE.QC}
                            isJobCompleted={isJobCompleted}
                        />
                    )}
                </Box>
            </Box>
        </Modal>
    )
}
